import React from "react";

const ReportEmbed = ({ iframeCode }: { iframeCode: string }) => {
  return (
    <div
      className="report-embed"
      dangerouslySetInnerHTML={{ __html: iframeCode }}
    />
  );
};

export default ReportEmbed;
